import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=a7f5d1dc&scoped=true"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=a7f5d1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f5d1dc",
  null
  
)

export default component.exports